import { render } from "./SideMenuOrgDataCom.vue?vue&type=template&id=38052f16&scoped=true"
import script from "./SideMenuOrgDataCom.vue?vue&type=script&lang=js"
export * from "./SideMenuOrgDataCom.vue?vue&type=script&lang=js"

import "@/assets/process_steps.css?vue&type=style&index=0&id=38052f16&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38052f16"]])

export default __exports__